// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContentArea-module__ui-ContentArea--yLH0B {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 0;
}

.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacing-none--PCP_D {
  padding: 0;
}

.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacing-medium--oc1H2 {
  padding: 36px 70px;
}

.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacing-large--lkhFg {
  padding: 48px 150px;
}

/* 축별 설정은 spacing보다 우선한다. */
.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacingX-none--Bdw7C {
  padding-left: 0;
  padding-right: 0;
}

.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacingX-medium--TLGJy {
  padding-left: 70px;
  padding-right: 70px;
}

.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacingX-large--pJwAF {
  padding-left: 150px;
  padding-right: 150px;
}

.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacingY-none--Vaj0Y {
  padding-top: 0;
  padding-bottom: 0;
}

.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacingY-medium--sOAJA {
  padding-top: 36px;
  padding-bottom: 36px;
}

.ContentArea-module__ui-ContentArea--yLH0B.ContentArea-module__spacingY-large--iYPj4 {
  padding-top: 48px;
  padding-bottom: 48px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/ContentArea/ContentArea.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".ui-ContentArea {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n}\n\n.ui-ContentArea.spacing-none {\n  padding: 0;\n}\n\n.ui-ContentArea.spacing-medium {\n  padding: 36px 70px;\n}\n\n.ui-ContentArea.spacing-large {\n  padding: 48px 150px;\n}\n\n/* 축별 설정은 spacing보다 우선한다. */\n.ui-ContentArea.spacingX-none {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.ui-ContentArea.spacingX-medium {\n  padding-left: 70px;\n  padding-right: 70px;\n}\n\n.ui-ContentArea.spacingX-large {\n  padding-left: 150px;\n  padding-right: 150px;\n}\n\n.ui-ContentArea.spacingY-none {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.ui-ContentArea.spacingY-medium {\n  padding-top: 36px;\n  padding-bottom: 36px;\n}\n\n.ui-ContentArea.spacingY-large {\n  padding-top: 48px;\n  padding-bottom: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-ContentArea": `ContentArea-module__ui-ContentArea--yLH0B`,
	"spacing-none": `ContentArea-module__spacing-none--PCP_D`,
	"spacing-medium": `ContentArea-module__spacing-medium--oc1H2`,
	"spacing-large": `ContentArea-module__spacing-large--lkhFg`,
	"spacingX-none": `ContentArea-module__spacingX-none--Bdw7C`,
	"spacingX-medium": `ContentArea-module__spacingX-medium--TLGJy`,
	"spacingX-large": `ContentArea-module__spacingX-large--pJwAF`,
	"spacingY-none": `ContentArea-module__spacingY-none--Vaj0Y`,
	"spacingY-medium": `ContentArea-module__spacingY-medium--sOAJA`,
	"spacingY-large": `ContentArea-module__spacingY-large--iYPj4`
};
export default ___CSS_LOADER_EXPORT___;
